/** Define Action Types */

// Set Side Rail data.
export const SIDE_RAIL_SOURCE_DATA_SET = "SIDE_RAIL_SOURCE_DATA_SET"

// Bulk update AG Grid table source data.
export const SOURCE_DATA_BULK_UPDATED = "SOURCE_DATA_BULK_UPDATED"
